import React, { useState } from 'react';
import AnimatedStep from '../components/AnimatedStep';
import StepOne from '../components/Questions/StepOne';
import StepTwo from '../components/Questions/StepTwo';
import StepThree from '../components/Questions/StepThree';
import StepFour from '../components/Questions/StepFour';
import StepFive from '../components/Questions/StepFive';
import StepSix from '../components/Questions/StepSix';
import StepSeven from '../components/Questions/StepSeven';
import StepEight from '../components/Questions/StepEight';
import StepNine from '../components/Questions/StepNine';
import StepTen from '../components/Questions/StepTen';
import StepEleven from '../components/Questions/StepEleven';
import StepTwelve from '../components/Questions/StepTwelve';
import StepThirteen from '../components/Questions/StepThirteen';
import StepFourteen from '../components/Questions/StepFourteen';
import StepFifteen from '../components/Questions/StepFifteen';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { post } from '../services/ApiService';

function Questions() {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleNext = (data) => {
        setFormData(prev => ({ ...prev, ...data }));
        console.log(formData);
        console.log("step:", step)
        // If current step is 15 (thank you page), call handleSubmit instead of increasing step
        if (step === 14) {
            handleSubmit();
        } else {
            setStep(prev => prev + 1);
        }
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            const res = await post("home/onboarding/submit", formData);
            if (res.success) {
                setStep(prev => prev + 1); // Move to success/thank you page
            } else {
                alert("Failed to submit");
            }
        } catch (error) {
            alert("Failed to submit");
        } finally {
            setIsSubmitting(false); // Always reset regardless of success/failure
        }
    }



    const handleBack = () => {
        setStep(prev => Math.max(prev - 1, 1));
    };

    const stepProps = {
        onNext: handleNext,
        formData,
    };

    const renderStep = () => {
        switch (step) {
            case 1: return <StepOne {...stepProps} />;
            case 2: return <StepTwo {...stepProps} />;
            case 3: return <StepThree {...stepProps} />;
            case 4: return <StepFour {...stepProps} />;
            case 5: return <StepFive {...stepProps} />;
            case 6: return <StepSix {...stepProps} />;
            case 7: return <StepSeven {...stepProps} />;
            case 8: return <StepEight {...stepProps} />;
            case 9: return <StepNine {...stepProps} />;
            case 10: return <StepTen {...stepProps} />;
            case 11: return <StepEleven {...stepProps} />;
            case 12: return <StepTwelve {...stepProps} />;
            case 13: return <StepThirteen {...stepProps} />;
            case 14: return <StepFourteen {...stepProps} isSubmitting={isSubmitting} />;
            case 15: return <StepFifteen {...stepProps} />;
            default: return null;
        }
    };

    return (
        <div className="container step_form_wrap py-2">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="step_form_wrap_main_ques">
                        {/* <Link to='/'> */}
                        <img
                            src="/assets/logo.png"
                            alt="Crowded Logo"
                            className='logo_steps'
                        />
                        {/* </Link> */}
                        {step !== 15 &&
                            <h5 className="my-4">Step {step} / 15</h5>
                        }


                        <AnimatedStep stepKey={step}>
                            {renderStep()}
                        </AnimatedStep>

                        <div className="d-flex justify-content-between bk_btn">
                            {step > 1 && step < 15 && (
                                <button className="btn btn-light btn-light-step px-4" onClick={handleBack}>
                                    Back
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Questions;
